import { StaffContext } from "contexts";
import React, { useContext, useMemo } from "react";
import { Switch, Redirect } from "react-router";
import { Route } from "react-router-dom";

const RouteRender = ({ renders, defaultRedirect }) => {
  const { staffAccess } = useContext(StaffContext);

  const render = useMemo(() => {
    if (!staffAccess.length) {
      return [
        Object.keys(renders).map((key) => {
          const route = renders[key];
          return {
            ...route,
            path: key,
          };
        }),
        defaultRedirect,
      ];
    }
    let firstPath = staffAccess.includes(defaultRedirect) ? defaultRedirect : "";
    const obj = Object.entries(renders)
      .filter(([path, route]) => {
        return staffAccess.includes(path) || staffAccess.includes(route.accessPath);
      })
      .map(([path, route]) => {
        if (!firstPath) {
          firstPath = path;
        }
        return {
          ...route,
          path,
        };
      });

    return [obj, firstPath];
  }, [renders, staffAccess, defaultRedirect]);
  return (
    <Switch>
      {render[0].map((item, key) => {
        if (item.redirectTo) {
          return (
            <Route
              exact={item.exact}
              path={item.path}
              key={key}
              render={({ match }) => (
                <Redirect
                  to={
                    typeof item.redirectTo === "function"
                      ? item.redirectTo(match.params)
                      : item.redirectTo
                  }
                />
              )}
            />
          );
        }
        return (
          (item.featureFlag === undefined || item.featureFlag) && (
            <Route component={item.component} exact={item.exact} path={item.path} key={key} />
          )
        );
      })}
      <Redirect to={render[1]} />
    </Switch>
  );
};

export default RouteRender;
